import React, { Component } from "react";
import { connect } from "react-redux";

import TopicsListComponent from "./TopicsListComponent";

import { fetchLatestTopics } from "Thunks";

export class TopicsList extends Component {
  componentDidMount() {
    const { fetchLatestTopics } = this.props;
    fetchLatestTopics({ limit: 12 });
  }

  render() {
    return <TopicsListComponent {...this.props} />;
  }
}

// Connected Component
const mapStateToProps = state => ({
  topics: state.topics.items,
  fetching: state.topics.fetching,
  fetched: state.topics.fetched,
  lng: state.params.lng
  //navCommunity: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({
  fetchLatestTopics: options => dispatch(fetchLatestTopics(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopicsList);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/TopicsList/index.js